import { DivIcon } from 'leaflet';

const interestPointSVG = `
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 2" width="34" height="48" viewBox="0 0 917 1299">
    <path fill="#0F5FA6" d="M917 459c0 156-78 295-198 377a409 409 0 0 0-156 213l-73 227a33 33 0 0 1-63 0l-73-229c-27-86-83-160-157-211a458 458 0 1 1 720-377z"/>
    <circle cx="458.5" cy="458.5" r="200" fill="#fff"/>
  </svg>`;

export const interestPointIcon = new DivIcon({
  html: interestPointSVG,
  className: '',
  iconSize: [34, 48],
  popupAnchor: [0, -24],
});
